export const PartnerId = "publisher-developer-store";
